import { useMutation, gql } from '@apollo/client';

export const REFRESH_INSTALLATIONS = gql`
  mutation RefreshInstallations {
    refreshInstallations(input: {}) {
      clientMutationId
    }
  }
`;

export const useRefreshInstallations = ({ onCompleted }) => {
  const [trigger, { loading }] = useMutation(REFRESH_INSTALLATIONS, { onCompleted });

  return {
    trigger,
    loading,
  };
};
